<template>
  <div id="wrap">
    <div class="crm-top">
      <div class="inner-wrap">
        <div class="top-main">
          <div class="h-btitle">私域流量 尽在掌控</div>
          <div class="h-stitle f-down-stitle">
            睿泽SCRM全面对接企业微信、打造基于社交生态的动态<br />
            客户管理系统；实现多渠道获客，低成本营销，高效客户<br />
            运营，增强客户转化率。
          </div>
          <div class="top-btn">
            <span class="wk-btn baidu_qiao" style="margin-right: 20px">咨询热线</span>
            <span class="top-tel">186-2966-7711</span>
          </div>
        </div>
        <img src="@/assets/v1/right.png" alt="" class="small-pic" />
      </div>
    </div>
    <div class="my-wechat">
      <div class="btitle">睿泽SCRM如何赋能您的企业微信</div>
      <div class="stitle">
        您在睿泽CRM中享受的所有功能，现在可以通过企业微信，获取不同的体验<br />
        帮助企业实现获客、营销、销售、服务和管理的一体化，客户价值与企业收益的最大化。
      </div>
      <div class="my-main">
        <div class="my-item">
          <img src="@/assets/v1/yinliu.png" alt="" class="my-icon" />
          <div class="my-txt">
            <div class="my-item-title">客户引流</div>
            <div class="my-item-desc">
              渠道活码、欢迎语、渠道分析等功能大范围引流<br />
              客户，实现企业高质量客户指数级增长。
            </div>
          </div>
        </div>
        <div class="my-item">
          <img src="@/assets/v1/jilu.png" alt="" class="my-icon" />
          <div class="my-txt">
            <div class="my-item-title">同步聊天记录</div>
            <div class="my-item-desc">
              整个公司业务的详细数据全面展示，并可通过<br />
              时间和部门进行筛选，支持数据导出。
            </div>
          </div>
        </div>
        <div class="my-item">
          <img src="@/assets/v1/kehu.png" alt="" class="my-icon" />
          <div class="my-txt">
            <div class="my-item-title">客户SOP</div>
            <div class="my-item-desc">
              定时提醒，新增好友，群发活动，生日提醒等sop <br />
              功能，让客户运行实现自动化，显著提升客户运<br />
              营效率。
            </div>
          </div>
        </div>
        <div class="my-item">
          <img src="@/assets/v1/huihua.png" alt="" class="my-icon" />
          <div class="my-txt">
            <div class="my-item-title">会话审计</div>
            <div class="my-item-desc">
              从员工列表、客户列表、群列表三个维度对聊天<br />
              记录进行多维展示、统计、并导出。
            </div>
          </div>
        </div>
        <div class="my-item">
          <img src="@/assets/v1/yunying.png" alt="" class="my-icon" />
          <div class="my-txt">
            <div class="my-item-title">群运营</div>
            <div class="my-item-desc">
              一键批量标签，群趋势曲线自动生成，发言率、<br />
              发言人数、进/退群人数等数据统计，多维度数据<br />
              排行等功能让群活跃度全面把控。
            </div>
          </div>
        </div>
        <div class="my-item">
          <img src="@/assets/v1/huashu.png" alt="" class="my-icon" />
          <div class="my-txt">
            <div class="my-item-title">智能话术</div>
            <div class="my-item-desc">
              支持图片、视频等多样优秀话术类型，一键发送<br />
              已建话术档案，避免浪费时间，有效提高客户转<br />
              化。
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="us-product" style="padding-top: 100px; background-color: #fff">
      <div class="btitle toggle-title">我们的服务</div>
      <div class="p-tab-box crm">
        <div class="p-tab-item lf" v-for="(item, index) in navArr" :key="index" @click="navClick(index)">
          <img :src="item.imgHov" class="p-tab-pic" v-if="navIndex == index" />
          <img :src="item.img" class="p-tab-pic" v-else />
          <div :class="['p-tab-title',navIndex == index ? 'pcolor' : '']">{{ item.title }}</div>
          <div :class="['red-tip',navIndex == index ? 'pactive' : '']"></div>
        </div>
      </div>
      <div class="p-content">
        <div class="middle-content">
          <div class="mcontent content1 opacityactive" style="background: #fafbfc" ref="content0">
            <div class="mcontent-main">
              <div class="mcontent-txt-pic">
                <div class="p-content-let">
                  <div class="p-content-let-btitle">多渠道获客</div>
                  <div class="p-content-let-stitle">
                    不管是在营销渠道还是咨询服务渠道都能够设立企业微信
                    渠道活码，将客户聚集到企业微信中来。
                  </div>
                </div>
                <div class="p-content-right">
                  <img src="@/assets/v1/b1.png" alt="" class="p-content-right-icon" />
                </div>
              </div>
              <div class="slide-list">
                <div class="slide-item">
                  <div class="slide-title">
                    <img src="@/assets/v1/q1.png" alt="" class="slide-icon" />
                    <span>渠道活码</span>
                  </div>
                  <div class="slide-desc">
                    企业可以根据不同场景生成相应的二维码，客户通过扫描二维码自动添加标签，增加客户画像丰富程度，增进员工对高效渠道的把控，推进对客户的了解。
                  </div>
                </div>
                <div class="slide-item">
                  <div class="slide-title">
                    <img src="@/assets/v1/q2.png" alt="" class="slide-icon" />
                    <span>树立企业形象</span>
                  </div>
                  <div class="slide-desc">
                    支持管理员与员工发布企业微信朋友圈，企业宣传，相关活动，产品优惠、客户福利等全线记录，增进客户对企业和产品的了解。
                  </div>
                </div>
                <div class="slide-item">
                  <div class="slide-title">
                    <img src="@/assets/v1/q3.png" alt="" class="slide-icon" />
                    <span>个性化欢迎语</span>
                  </div>
                  <div class="slide-desc">
                    各渠道多场景可自定义配置相应的欢迎语、图片、表情、文字等多模态的结合更容易让客户感受到企业的关注，优化客户体验。
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mcontent content2" style="background: #fff" ref="content1">
            <div class="mcontent-main">
              <div class="mcontent-txt-pic">
                <div class="p-content-let">
                  <div class="p-content-let-btitle">精细化销售</div>
                  <div class="p-content-let-stitle">
                    从线索的获取，筛选到转换为潜在客户，每一步都可根据
                    线索的跟进情况作出下一步正确的决策，把握更多高质量 线索。
                  </div>
                </div>
                <div class="p-content-right">
                  <img src="@/assets/v1/b2.png" alt="" class="p-content-right-icon" />
                </div>
              </div>
              <div class="slide-list">
                <div class="slide-item">
                  <div class="slide-title">
                    <img src="@/assets/v1/x1.png" alt="" class="slide-icon" />
                    <span>线索管理</span>
                  </div>
                  <div class="slide-desc">
                    通过企业微信，与客户个性化互动，快速收集线索信息。当线索表现出对产品或服务的购买意向时，一键转化为商机。管理流程贯穿全生命周期，把握高质量线索，抓住更多商机。
                  </div>
                </div>
                <div class="slide-item">
                  <div class="slide-title">
                    <img src="@/assets/v1/x2.png" alt="" class="slide-icon" />
                    <span>商机管理</span>
                  </div>
                  <div class="slide-desc">
                    自定义筛选和搜索，多角度横向查看整体商机状态。活动记录、跟进状态与进程一览表的设置，纵向把控商机进度。纵横交错，帮助销售人员立体把控业务进度。
                  </div>
                </div>
                <div class="slide-item">
                  <div class="slide-title">
                    <img src="@/assets/v1/x3.png" alt="" class="slide-icon" />
                    <span>合同管理</span>
                  </div>
                  <div class="slide-desc">
                    从合同创建，到审批，直至落实到执行，全面规范合同流程，更好的促进企业项目的进行，并支持对回款的管理，推动企业效益的实现。
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mcontent content3" style="background: #fafbfc" ref="content2">
            <div class="mcontent-main">
              <div class="mcontent-txt-pic">
                <div class="p-content-let">
                  <div class="p-content-let-btitle">高效客户运营</div>
                  <div class="p-content-let-stitle">
                    私域管理，实现企业全权管理客户资源，并提供聊天窗口
                    侧边工具栏功能，提高管理精细化程度。
                  </div>
                </div>
                <div class="p-content-right">
                  <img src="@/assets/v1/b3.png" alt="" class="p-content-right-icon" />
                </div>
              </div>
              <div class="slide-list">
                <div class="slide-item">
                  <div class="slide-title">
                    <img src="@/assets/v1/k1.png" alt="" class="slide-icon" />
                    <span>微信好友转为CRM联系人</span>
                  </div>
                  <div class="slide-desc">
                    微信/企业微信与睿泽全面打通，添加在企业微信上的客户同步转为CRM联系人，完全归企业所有，免去人工重复录入，帮助客户信息全沉淀，避免离职导致的客户信息流失，实现真正的私域流量管理。
                  </div>
                </div>
                <div class="slide-item">
                  <div class="slide-title">
                    <img src="@/assets/v1/k2.png" alt="" class="slide-icon" />
                    <span>工具栏</span>
                  </div>
                  <div class="slide-desc">
                    企业微信侧边工具栏快捷展示客户所有相关信息：渠道、标签、跟进记录、相关产品、签署合同等。促进运营过程高效进行，无需打开多余界面。
                  </div>
                </div>
                <div class="slide-item">
                  <div class="slide-title">
                    <img src="@/assets/v1/k3.png" alt="" class="slide-icon" />
                    <span>同步跟进记录</span>
                  </div>
                  <div class="slide-desc">
                    企业微信中与任何客户的聊天记录可实时同步到睿泽CRM的跟进记录中，随时反馈跟进情况并建立下一步联系计划。把握客户需求，及时联系维护，促成二次合作。
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mcontent content4" style="background: #fff" ref="content3">
            <div class="mcontent-main">
              <div class="mcontent-txt-pic">
                <div class="p-content-let">
                  <div class="p-content-let-btitle">多玩法裂变传播</div>
                  <div class="p-content-let-stitle">
                    以任务海报为形式，提供具有吸引力的奖品或发送红包等
                    作为奖励，通过抽奖、推介客户、做任务等多种线上裂变
                    形式，在活跃企业品牌度的同时，帮助企业指数级获取高 质量客户。
                  </div>
                </div>
                <div class="p-content-right">
                  <img src="@/assets/v1/b4.png" alt="" class="p-content-right-icon" />
                </div>
              </div>
              <div class="slide-list">
                <div class="slide-item">
                  <div class="slide-title">
                    <img src="@/assets/v1/l1.png" alt="" class="slide-icon" />
                    <span>企业微信社群裂变</span>
                  </div>
                  <div class="slide-desc">
                    以社群为载体，通过诱饵包装，以海报的形式吸引用户入群，通过话术提醒，引导用户完成海报转发任务，吸引更多用户。
                  </div>
                </div>
                <div class="slide-item">
                  <div class="slide-title">
                    <img src="@/assets/v1/l2.png" alt="" class="slide-icon" />
                    <span>企业微信好友裂变</span>
                  </div>
                  <div class="slide-desc">
                    用户扫码添加企业微信，企业微信自动推送活动规则和用户专属分享海报，用户只有转发海报让其他人添加企业微信，达到一定的人数后才算完成任务，并获得奖励。
                  </div>
                </div>
                <div class="slide-item">
                  <div class="slide-title">
                    <img src="@/assets/v1/l3.png" alt="" class="slide-icon" />
                    <span>企业微信任务裂变</span>
                  </div>
                  <div class="slide-desc">
                    用户扫码关注公众号，公众号弹出企业微信二维码，添加企业微信，获取专属海报及活动规则文案，用户转发海报，邀请好友为自己助力，好友关注公众号，并且成功添加企业微信，则助力成功，用户完成任务，领取奖品。
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mcontent content5" style="background: #fafbfc" ref="content4">
            <div class="mcontent-main">
              <div class="mcontent-txt-pic">
                <div class="p-content-let">
                  <div class="p-content-let-btitle">运营管理</div>
                  <div class="p-content-let-stitle">
                    更好的服务客户运营，提供全场景营销效果分析，从运营
                    数据全面统计分析，到与客户沟通逾期提醒，从宏观和微
                    观全面提升运营质量与效率。同时会话存档功能让您全线
                    管控运营过程。
                  </div>
                </div>
                <div class="p-content-right">
                  <img src="@/assets/v1/b5.png" alt="" class="p-content-right-icon" />
                </div>
              </div>
              <div class="slide-list">
                <div class="slide-item">
                  <div class="slide-title">
                    <img src="@/assets/v1/y1.png" alt="" class="slide-icon" />
                    <span>运营数据统计</span>
                  </div>
                  <div class="slide-desc">
                    对线索数量，商机数量，获客数量等的增减权限记录，并可实时查看，自动生成统计报告与销售漏斗，全面掌握客户数据。
                  </div>
                </div>
                <div class="slide-item">
                  <div class="slide-title">
                    <img src="@/assets/v1/y2.png" alt="" class="slide-icon" />
                    <span>限时提醒</span>
                  </div>
                  <div class="slide-desc">
                    员工待联系客户或待回复信息等逾期前自动提醒，优化服务质量，提升服务效率。
                  </div>
                </div>
                <div class="slide-item">
                  <div class="slide-title">
                    <img src="@/assets/v1/y3.png" alt="" class="slide-icon" />
                    <span>会话存档</span>
                  </div>
                  <div class="slide-desc">
                    会话存档，随时调取，规范员工工作行为，保护企业资产。同时可设置客户流失提醒、员工删除客户预警等，帮助企业风险管控。
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <understand />
    <div class="other">
      <div class="btitle" style="margin-bottom: 60px">成功案例</div>
      <div class="other-main">
        <div class="other-item" v-for="(item, index) in successArr" :key="index">
          <div class="other-item-btitle">{{ item.title }}</div>
          <div class="other-btn">
            <div class="btn-item" v-for="(item1, index1) in item.label" :key="index1">{{ item1 }}</div>
          </div>
          <span class="look-detail">
            <router-link :to="`successcase/${item.link}`" class="detail">查看详情 &gt;</router-link>
          </span>
          <img :src="item.img" class="crm-hrm-fs-icom" />
        </div>
      </div>
    </div>
    <choice />
    <cooperation />
  </div>
</template>
<script>
import choice from '@/components/choice'
import understand from '@/components/understand'
import cooperation from '@/components/cooperation'





export default {
  name: 'SuccessCase',
  components: { choice, understand, cooperation },
  data() {
    return {
      navIndex: 0,
      navArr: [
        {
          img: require('@/assets/v1/p1.png'),
          imgHov: require('@/assets/v1/pa1.png'),
          title: '获客渠道'
        },
        {
          img: require('@/assets/v1/p2.png'),
          imgHov: require('@/assets/v1/pa2.png'),
          title: '销售管理'
        },
        {
          img: require('@/assets/v1/p3.png'),
          imgHov: require('@/assets/v1/pa3.png'),
          title: '客户运营'
        },
        {
          img: require('@/assets/v1/p4.png'),
          imgHov: require('@/assets/v1/pa4.png'),
          title: '裂变传播'
        },
        {
          img: require('@/assets/v1/p5.png'),
          imgHov: require('@/assets/v1/pa5.png'),
          title: '运营管理'
        }
      ],
      successArr: [
        {
          img: require('@/assets/v1/ahrm.png'),
          title: '农业农村局：“四网融合”推动“三资”智慧监管',
          link: 'assets',
          label: [
            '大屏数据',
            '四网融合',
            '凭证管理',
            '账簿管理',
            '财务报表',
            '辅助核算',
            '精细化科目管理'
          ]
        },
        {
          img: require('@/assets/v1/afs.png'),
          title: '招商局：多共享中心成就数字化的招商局',
          link: 'merchants',
          label: [
            '金蝶EAS',
            '共享中心',
            '商务管理',
            '预算分析',
            '绩效管理',
            '财务筹划',
            '汇率风险管理'
          ]
        },
        {
          img: require('@/assets/v1/ajxc.png'),
          title: '京东科技：业财协同推动集团精细化运营',
          link: 'jd',
          label: [
            '物联网',
            '区块链',
            'AI',
            '数字营销',
            '财务核算',
            '费控系统'
          ]
        },
        {
          img: require('@/assets/v1/azsk.png'),
          title: '德邦物流：川流汇聚 精准服务',
          link: 'debang',
          label: [
            '金蝶EAS',
            '异构系统',
            '财务核算系统',
            '集成异构系统',
            '合并报表',
            '利润中心'
          ]
        }
      ]
    }
  },
  mounted() {
    document.querySelector('#wrap').scrollIntoView(true)
  },
  beforeDestroy() {
  },
  methods: {
    navClick(index) {
      this.navIndex = index
      this.$refs[`content${index}`].scrollIntoView(
        {
          behavior: "smooth",
          block: "start"
        }
      );
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
}
.crm-top {
    background-color: #FAFBFC;
    text-align: left;
}
.inner-wrap {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    position: relative;
}
.top-main {
    width: 1200px;
    margin: 0 auto;
    padding-top: 100px;
    padding-bottom: 110px;
    position: relative;
}
.small-pic {
    position: absolute;
    right: 0;
    width: 55%;
    border: none;
    vertical-align: middle;
    display: inline-block;
}
.h-btitle {
    color: #172B4D;
    font-size: 42px;
    line-height: 60px;
}
.f-down-stitle {
    margin: 10px 0 35px;
}
.h-stitle {
    line-height: 30px;
    font-size: 20px;
    color: #42526E;
}
.wk-btn {
    padding: 15px 30px;
    background-color: #0252CC;
    border-radius: 3px;
    font-size: 16px;
    color: #fff;
    cursor: pointer;
    display: inline-block;
}
.top-tel {
    color: #0052CC;
    font-size: 16px;
}
.my-wechat {
    padding-top: 100px;
    background-color: #fff;
}
.btitle {
    font-size: 36px;
    line-height: 50px;
    color: #172B4D;
    text-align: center;
}
.stitle {
    text-align: center;
    font-size: 16px;
    color: #42526E;
    line-height: 24px;
    margin-top: 20px;
    margin-bottom: 70px;
}
.my-wechat .my-main {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
}
.my-wechat .my-main .my-item {
    width: 355px;
    margin: 10px 20px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
}
.my-wechat .my-main .my-item .my-icon {
    width: 40px;
    height: 40px;
    display: inline-block;
    margin-right: 10px;
    border: none;
    vertical-align: middle;
}
.my-wechat .my-main .my-item .my-item-title {
    color: #253858;
    font-size: 18px;
    margin-top: 10px;
    margin-bottom: 10px;
}
.my-wechat .my-main .my-item .my-item-desc {
    color: #42526E;
    font-size: 14px;
    line-height: 24px;
    text-align: justify;
}
.us-product {
    width: 100%;
    padding-top: 60px;
    background-color: #fff;
    text-align: left;
}
.toggle-title {
    margin-bottom: 60px;
}
.p-tab-box {
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
}
.crm .p-tab-item {
    width: 150px;
    text-align: center;
    margin-right: 112px;
    cursor: pointer;
}
.crm .p-tab-item:nth-child(5) {
    margin-right: 0;
}
.lf {
    float: left;
}
.p-tab-pic {
    width: 88px;
    height: 100px;
    margin-bottom: 10px;
    display: inline-block;
    border: none;
    vertical-align: middle;
}
.p-tab-title {
    font-size: 18px;
    color: #111111;
}
.red-tip {
    width: 0%;
    height: 4px;
    padding-bottom: 15px;
    transition: width 1s;
}
.p-tab-box .pcolor {
    color: #0252CC;
}
.p-tab-box .pactive {
    display: block;
    width: 100%;
    margin: 0 auto;
    border-bottom: 4px solid #0252CC;
}
.p-content {
    width: 100%;
    background: #FAFCFE;
}
.middle-content {
    width: 100%;
    margin: 0 auto;
    padding-top: 50px;
    overflow: hidden;
}
.mcontent {
    width: 100%;
    margin: 0 auto;
    animation: fade-in 1.3s ease-out 1 forwards;
    -webkit-animation: fade-in 1.3s ease-out 1 forwards;
    transition: all 0.8s ease 1s;
}
.mcontent-main {
    width: 1200px;
    margin: 0 auto;
}
.p-content .middle-content .mcontent .mcontent-txt-pic {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    padding-top: 50px;
    padding-bottom: 50px;
}
.p-content .middle-content .mcontent .mcontent-txt-pic .p-content-let {
    width: calc(100% - 800px);
}
.p-content .middle-content .mcontent .mcontent-txt-pic .p-content-let-btitle {
    color: #172B4D;
    font-size: 28px;
    margin-bottom: 10px;
    font-weight: bold;
}
.p-content .middle-content .mcontent .mcontent-txt-pic .p-content-let-stitle {
    color: #42526E;
    font-size: 16px;
    line-height: 26px;
    margin-top: 20px;
    text-align: justify;
}
.p-content-right {
    width: 762px;
}
.p-content-right .p-content-right-icon {
    width: 100%;
    display: inline-block;
    border: none;
    vertical-align: middle;
}
.slide-list {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    padding-top: 30px;
    padding-bottom: 30px;
}
.slide-list .slide-item {
    width: 30%;
    margin-right: 40px;
    margin-bottom: 20px;
    padding: 34px;
    border-radius: 4px;
}
.slide-list .slide-item .slide-title {
    color: #172B4D;
    font-size: 18px;
    margin-bottom: 10px;
    font-weight: bold;
}
.slide-icon {
    width: 24px;
    height: 24px;
    display: inline-block;
    border: none;
    vertical-align: middle;
}
.slide-list .slide-item .slide-desc {
    color: #42526E;
    font-size: 14px;
    line-height: 22px;
    text-align: justify;
}
@-webkit-keyframes fade-in {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
@-moz-keyframes fade-in {
  0% {
    opacity: 0;
  }
  50% {
      opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
@-ms-keyframes fade-in {
  0% {
    opacity: 0;
  }
  50% {
      opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  50% {
      opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
.other {
    padding-top: 128px;
    padding-bottom: 128px;
    background: #FFFFFF;
    text-align: left;
}
.other .other-main {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
}
.other .other-main .other-item {
    width: 490px;
    position: relative;
    box-shadow: 0px 2px 12px 0px #d7dbdf;
    border-radius: 3px;
    padding: 35px 20px;
    margin: 0 30px 30px;
    overflow: hidden;
}
.other .other-main .other-item .other-item-btitle {
    color: #172B4D;
    font-size: 20px;
    margin-bottom: 5px;
    font-weight: bold;
}
.other .other-main .other-item .other-item-stitle {
    color: #42526E;
    font-size: 14px;
    line-height: 22px;
}
.other .other-main .other-item .other-btn {
    width: 314px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 20px;
    margin-bottom: 10px;
}
.other .other-main .other-item .other-btn .btn-item {
    line-height: normal;
    border: 1px solid #DFE1E6;
    padding: 5px;
    color: #6B778C;
    font-size: 14px;
    margin-right: 10px;
    margin-bottom: 10px;
}
.look-detail {
    font-size: 14px;
    color: #0252CC;
}
.detail {
    color: #0252CC;
}
.detail:hover {
    color: #fa9046;
}
.crm-hrm-fs-icom {
    width: 150px;
    position: absolute;
    right: 0;
    bottom: -16px;
    z-index: 0;
    display: inline-block;
    border: none;
    vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/views/successcase/components/Banner.vue